import { effect, inject, Injectable } from '@angular/core';
import { AuthStore } from '../stores/auth.store';
import { JwtService } from './jwt.service';

@Injectable({ providedIn: 'root' })
export class AuthBootstrapService {
  private authStore = inject(AuthStore);
  private jwtService = inject(JwtService);

  async initialize(): Promise<void> {
    const token = this.jwtService.getToken();

    if (!token) {
      this.authStore.purgeAuth();
      return;
    }

    return new Promise((resolve) => {
      this.authStore.populate();

      // Wait until store finishes hydration
      const ref = effect(() => {
        if (
          this.authStore.currentUser() !== null ||
          this.authStore.error() !== null
        ) {
          ref.destroy();
          resolve();
        }
      });
    });
  }
}
